import {
  Backdrop,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Portal,
} from "@material-ui/core";
import React, { useState } from "react";
import { useOrderHandler } from "../../hooks/rest";
import { useMessageValue } from "../../context";
import { Message, MessageType } from "../../constants/message";

function ProcessOrderRetry({ orderToProcess, openProcessModal, setOpenProcessModal, updateOrderDetails }) {
  const { placeOrderRetry } = useOrderHandler();
  const { setMessage } = useMessageValue();
  const [loading, setLoading] = useState(false);

  const handleProcessItemConfirm = () => {
    if (orderToProcess) {
      setLoading(true);
      const [respProcessOrder] = placeOrderRetry(orderToProcess);
      respProcessOrder
        .then((resp) => {
          updateOrderDetails();
          setLoading(false);
          setOpenProcessModal(false);
          const message = "Orden procesada correctamente.";
          const errorMessage: Message = {
            type: MessageType.SUCCESS,
            message,
          };
          setMessage(errorMessage);
        })
        .catch((error) => {
          // TODO Handle Error
          setLoading(false);
          setOpenProcessModal(false);

          if (error.response && error.response.data && error.response.data.error) {
            const message = error.response.data.error.message;
            const errorMessage: Message = {
              type: MessageType.ERROR,
              message,
            };
            setMessage(errorMessage);
          }
        });
    }
  };

  return (
    <>
      <Dialog open={openProcessModal} onClose={() => setOpenProcessModal(false)}>
        <DialogTitle>
          Confirmar Acción
          <Button
            onClick={() => setOpenProcessModal(false)}
            style={{
              position: "absolute",
              top: 8,
              right: 8,
            }}>
            X
          </Button>
        </DialogTitle>
        <DialogContent>
          <DialogContentText>Hacer click en Aceptar para iniciar el procesamiento de la orden.</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleProcessItemConfirm} variant="contained" color="primary">
            {loading ? "Procesando..." : "Aceptar"}
          </Button>
        </DialogActions>
      </Dialog>
      <Portal>
        <Backdrop
          sx={{
            color: "#fff",
            zIndex: 2000,
          }}
          style={{
            zIndex: 2000,
          }}
          open={loading}>
          <CircularProgress color="primary" />
        </Backdrop>
      </Portal>
    </>
  );
}

export default ProcessOrderRetry;
